<template>
  <div>
    <core-main>
      <template v-slot:toolbar-title>
        {{ $t('form.userPreferences.name') }}
      </template>

      <v-container class="fill-height">
        <v-row justify="center" style="height: 100%; margin-top: 5%;">
          <v-col cols="10">
            <form-user-preferences @update-entity="updateUser" />
          </v-col>
        </v-row>
      </v-container>
    </core-main>
  </div>
</template>
<script>
import UpdateEntityMixin from '../mixins/update-entity';
import UsersMixins from '../mixins/users';

export default {
  name: 'UserPreferences',

  mixins: [
    UpdateEntityMixin,
    UsersMixins,
  ],

  mounted() {
    this.fetchUsers({ query: {} });
  },

  methods: {
    async updateUser(tab, user) {
      // const userModel = await this.getUser(user._id);

      const { User } = this.$FeathersVuex.api;
      const newUser = new User(user);

      this.updateEntity(undefined, newUser);
    },
  },
};
</script>

<style scoped>

</style>
